import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const ButtonContainer = styled(Box).attrs({
  p: 13,
  my: 11,
})`
  border: ${({ theme }) => `1px solid ${theme.colors.heavyLineOutline};}`};
`;
